import { render, staticRenderFns } from "./NpsChartAdmin.vue?vue&type=template&id=718bbf25"
import script from "./NpsChartAdmin.vue?vue&type=script&lang=js"
export * from "./NpsChartAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports